import { adminPaths } from "@app/routing/adminPaths";
import { useBreadcrumb } from "@app/shared/components/Breadcrumb/useBreadcrumb";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useObjective } from "../data";
import { keys, RESOURCE_NAME } from "../i18n";

export function useObjectivesBreadcrumb() {
    const { objective_id } = useParams();
    const { objective: currentObjective } = useObjective(objective_id);
    const { t } = useTranslation(RESOURCE_NAME);

    const breadcrumbArgs = useMemo(() => {
        return [
            adminPaths.objective_id_param,
            currentObjective?.name ?? "...",
        ] as const;
    }, [objective_id, currentObjective]);

    const setBreadcumb = useBreadcrumb();

    useEffect(() => {
        const [path, name] = breadcrumbArgs;
        setBreadcumb(path, name);
        setBreadcumb(adminPaths.objectives, t(keys.breadcrumb_objectives));
    }, [breadcrumbArgs]);
}
